module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b2eb9c0f6676de1f1b94e3a0b3a43e11.png";